// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState, useEffect } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import Modal from '../../../utils/ModalComponet';
import ActivitiesBulkUploadPreviewContent from './ActivitiesBulkUploadPreviewContent/ActivitiesBulkUploadPreviewContent';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const ActivitiesBulkUploadPreview = ({ isOpen, closeModal, onSend }) => {
  const [activities, setActivities] = useState(null);
  const [bookingOptions, setBookingOptions] = useState(null);

  useEffect(() => {
    setActivities(null);
    setBookingOptions(null);
  }, [isOpen]);

  return (
    <Modal
      open={isOpen}
      closeModal={closeModal}
      cancel={closeModal}
      action={() => onSend({ activities, bookingOptions })}
      actionButtonText='Upload'
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      disabled={!activities || !activities.length}
      stylesProps={{
        width: '85vw',
        height: '90vh',
        maxWidth: 'none',
        background: '#F7F7F7',
      }}
    >
      <ActivitiesBulkUploadPreviewContent
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        activities={activities}
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        setActivities={setActivities}
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        bookingOptions={bookingOptions}
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        setBookingOptions={setBookingOptions}
      />
    </Modal>
  );
};

export default ActivitiesBulkUploadPreview;
